<template>
  <div :class="$b()">
    <div
      :class="$b('text' , { expanded })"
      :style="[ expanded ? { maxHeight: `${textContainerHeight}px` } : '']"
      :aria-expanded="expanded ? 'true' : 'false'"
    >
      <div ref="bodyText">
        <slot name="body-text" />
      </div>
    </div>

    <VisionLink
      :class="$b('expand-btn')"
      line-link
      is-button
      primary
      @click="expanded = !expanded"
    >
      {{ $tr(buttonText) }}
    </VisionLink>
  </div>
</template>

<script>
import { debounce } from '~/assets/js/helpers'

export default {
  name: 'ExpandingTextBlock',

  props: {
    buttonTextMore: {
      type: String,
      default: 'Read More'
    },
    buttonTextLess: {
      type: String,
      default: 'Show Less'
    }
  },

  data () {
    return {
      expanded: false,
      textContainerHeight: 0
    }
  },

  computed: {
    buttonText () {
      return this.expanded ? this.buttonTextLess : this.buttonTextMore
    }
  },

  mounted () {
    window.addEventListener('resize', debounce(this.getContainerHeight, 500))
    this.getContainerHeight()
  },

  beforeUnmount () {
    window.removeEventListener('resize', debounce(this.getContainerHeight, 500))
  },

  methods: {
    toggleReview () {
      this.expanded = !this.expanded
    },
    getContainerHeight () {
      if (this.$refs.bodyText) {
        this.textContainerHeight = this.$refs.bodyText.clientHeight
      }
    }
  }
}
</script>

<style lang="postcss">
.ExpandingTextBlock__text {
  @apply relative;

  max-height: 220px;
  overflow: hidden;
  transition: max-height .2s ease-out, margin .1s ease-out;
  white-space: pre-line;

  &:after {
    @apply absolute
      w-full;

    bottom: 0;
    content: '';
    background: linear-gradient(0deg, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%);
    height: 60%;
    transition: height .2s ease-in-out;
  }

  &--expanded {
    @apply mb-sm;

    &:after {
      height: 0;
    }
  }
}

.ExpandingTextBlock__expand-btn {
  @apply text-xxs inline-block;
}
</style>
